import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const VideoIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "VideoIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.8697 4.086H3.20962C2.88887 4.086 2.62891 4.34596 2.62891 4.66671V20.0533C2.62891 20.3741 2.88887 20.634 3.20962 20.634H21.8697C22.1904 20.634 22.4504 20.3741 22.4504 20.0533V4.6667C22.4504 4.34595 22.1904 4.086 21.8697 4.086ZM8.8836 18.4615V19.4726H6.93506V18.4615H8.8836ZM10.045 18.4615H11.9935V19.4726H10.045V18.4615ZM13.155 18.4615H15.1037V19.4726H13.155V18.4615ZM16.2651 18.4615H18.2136V19.4726H16.2651V18.4615ZM3.79032 17.3001V7.41992H21.2889V17.3001L3.79032 17.3001ZM16.2651 6.25851V5.24741H18.2136V6.25851H16.2651ZM15.1037 6.25851H13.155V5.24741H15.1037V6.25851ZM11.9936 6.25851H10.045V5.24741H11.9936V6.25851ZM8.88361 6.25851H6.93507V5.24741H8.88361V6.25851ZM21.289 6.25851H19.375V5.24741H21.289V6.25851ZM5.77365 5.24741V6.25851H3.79032V5.24741H5.77365ZM3.79032 18.4615H5.77365V19.4726H3.79032V18.4615ZM19.375 19.4726V18.4615H21.2889V19.4726H19.375Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.6872 11.7617C14.6715 11.7502 14.655 11.7395 14.638 11.7296L11.3153 9.79002C11.0746 9.63259 10.7582 9.61475 10.4981 9.74722C10.2419 9.87743 10.0828 10.1316 10.0828 10.4105V14.3095C10.0828 14.5884 10.2419 14.8425 10.4981 14.9728C10.6145 15.0321 10.7423 15.0613 10.8695 15.0613C11.0263 15.0613 11.1824 15.017 11.3153 14.9299L14.638 12.9904C14.655 12.9806 14.6715 12.9698 14.6872 12.9583C14.8836 12.8151 14.9965 12.5972 14.9965 12.3601C14.9965 12.123 14.8836 11.9048 14.6872 11.7617ZM11.2444 13.6265V11.0934L13.4142 12.3599L11.2444 13.6265Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default VideoIcon;
